import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ActivityIndicator, TouchableOpacity, View } from "react-native"
import { Icon } from 'react-native-elements';
import { connect, useDispatch, useSelector } from "react-redux"
import Colors from '../../../constants/Colorsv2';
import { Text } from '../../../globalComponents/NativeOverrides';
import { event_getAthleteByAthleteId, event_getEventByEventId, event_getTournamentByTournamentId } from '../../../store/actionsv1/events';
import { market_getLatestTradesByEventId, market_setDraftOrder } from '../../../store/actionsv1/markets';
import { EventOrderStatProps, MarketProps, OrderProps, TradeProps } from '../../../store/types/mk_svc';
import { AthleteProps, EventProps, TournamentProps } from '../../../store/types/sr_svc';
import { PlayerPickProps } from '../../../store/types/tp_svc';
import { useIsInViewport } from '../../../utilsv1/helpers';
import { market_getMarketsFromArrayOfIds, market_getMarketsFromSupportedMarkets } from '../helpers/markets';
import { trade_getOrderFromTrade, trade_getTradeFromMarket } from '../helpers/trades';
import MarketCard from './MarketCard';
import MarketCardFooter from './MarketCardFooter';
import MarketEventCard from "./MarketEventCard"
import { AthleteImage } from '../../../assets/icons';

type AthleteEventCardProps = {
    navigation:any,
    event_id: string,
    event_type: 'team'|'tournament'|'match';
    market_override?:MarketProps,
    picks?:PlayerPickProps[],
    close_markets?:boolean,
    hide_event_info?:boolean,
    trades_override?:TradeProps[],
    lock_markets?:boolean,
    source?:'market'|'competition_create'|'competition_play'
    onCompPick?: (trade:TradeProps) => void
    add_to_comp_value?: boolean,
    onAddToComp?: (event:EventProps) => void
    athlete_id: string,
    hide_stat?:boolean,
    do_not_load_athlete?:boolean,
    hide_market_footers?:boolean,
}
const AthleteEventCard = ({ navigation, source, picks, hide_stat, do_not_load_athlete, lock_markets, onCompPick, hide_event_info, event_id, event_type, close_markets, trades_override, athlete_id, hide_market_footers, market_override }:AthleteEventCardProps) => {
    const [ loaded, setLoaded ] = useState(false);
    const dispatch = useDispatch()
    //State Objects
    const event:EventProps | undefined = useSelector((state:any) => state.event.events[event_id], (left, right) => left?.time_detail === right?.time_detail)
    const tournament:TournamentProps | undefined = useSelector((state:any) =>  state.event.tournaments[event_id], (left, right) => left?.tournament_id == right?.tournament_id)
    const athlete:AthleteProps | undefined = useSelector((state:any) => state.event.athletes_list.athletes.find((a:AthleteProps) => a.athlete_id == athlete_id), (left, right) => left?.athlete_id == right?.athlete_id)
    const markets:MarketProps[] = useSelector((state:any) => state.market.markets, (left, right) => left.length === right.length)
    let order_stats:EventOrderStatProps[] | undefined = useSelector((state:any) => state.market.order_stats[`${event_type}:${event_id}`], (left, right) => left == right)
    if(!order_stats){ order_stats = [] }
    order_stats = order_stats.filter(os => os.side_id == athlete_id && market_override?.market_id == os.market_id)
    const open_order_count = order_stats.reduce((a,b) => a + parseInt(b.open_order_count), 0)
    const open_order_amount = order_stats.reduce((a,b) => a + parseFloat(b.open_order_amount), 0)
    //const athlete_ref = useRef()
    //const isInViewport1 = useIsInViewport(athlete_ref)
    let available_markets:MarketProps[] = []
    if(event_type === 'team'){ available_markets = market_getMarketsFromSupportedMarkets(event?.supported_markets??[], markets) }
    if(event_type === 'tournament'){ available_markets = market_getMarketsFromSupportedMarkets(tournament?.supported_markets??[], markets) }
       
    useEffect(() => {
        if(!loaded){
            getDataFromServer(event_id, athlete_id)
        }
    },[])
    
    const getDataFromServer = async(event_id:string, athlete_id:string) => {
        if(!do_not_load_athlete && !athlete){ 
            await dispatch(event_getAthleteByAthleteId(athlete_id)) }
        if(!event && event_type === 'team') { await dispatch(event_getEventByEventId(event_id)) }
        if(!tournament && event_type === 'tournament'){ await dispatch(event_getTournamentByTournamentId(event_id)) }
        await market_getLatestTradesByEventId(event_id, event_type)
        setLoaded(true)
    }

    const handleSelectTrade = (trade:TradeProps) => {
        if(event_type === 'team' && !event){ return }
        if(event_type === 'tournament' && !tournament){ return }
        if(!athlete){ return }
        if(source === 'competition_create'){ return }
        if(source === 'competition_play'){
            if(!onCompPick){ return }
            return onCompPick(trade)
        }
        return dispatch(market_setDraftOrder(trade_getOrderFromTrade(trade)))
    }
    if(!athlete || !market_override){ return <></> }
    return (
        
        <View style={ styles.cardStyle }>
            {athlete.team ?
            <View style={{ flexDirection:'row', alignItems:'center', padding:7, backgroundColor:Colors.shades.shade100, borderTopRightRadius:12, borderTopLeftRadius:12 }}>
                <Text style={{ flex:1 }} weight='semibold' size={12} color={Colors.brand.midnight}>{athlete.team.market_name} {athlete.team.name}</Text>                
            </View>
            :<></>}
            <View style={{ padding:7 }}>
                {!hide_event_info ?
                <View style={{ paddingBottom:5 }}>
                    {event_type === 'tournament' && tournament ?
                    <View nativeID='tournament_info' style={{ flexDirection:'row', justifyContent:'space-between' }}>
                        <Text size={12} color={Colors.brand.slate}>{tournament.tournament_name}</Text>
                        <Text size={12} color={Colors.brand.slate}>{tournament.time_detail}</Text>                    
                    </View>
                    :<></>}
                    {event_type === 'team' && event ?
                    <View nativeID='event_info' style={{ flexDirection:'row', justifyContent:'space-between' }}>
                        <Text size={12} color={Colors.brand.slate}>{event.event_title}</Text>
                        <Text size={12} color={Colors.brand.slate}>{event.time_detail}</Text>                    
                    </View>
                    :<></>}
                </View>
                :<></>}
                <View style={{ flexDirection:'row', alignItems:'center' }}>
                    <View nativeID='athlete_image'>
                        <AthleteImage size={45} number_size={16} athlete={athlete}/>    
                    </View>
                    <View nativeID='athlete-info' style={{ flex:1 }}>
                        <Text size={12} color={Colors.brand.midnight} weight='bold'>{athlete.first_name} {athlete.last_name} ({athlete.position})</Text>
                        <Text size={12} color={Colors.brand.midnight} weight='regular'>{market_override.stat_label?market_override.stat_label:market_override.description}</Text>
                    </View>
                    {!close_markets && !lock_markets ?
                    <View style={{ flex:1 }}>
                        {available_markets.map(m => {
                            if(market_override && market_override.market_id != m.market_id){ return }
                            let side_array:any = []
                            m.side_options.map(o => {
                                let side:any = { side: o.side }
                                if(o.id_source === 'athlete'){ side.side_id = athlete_id }
                                else { side.side_id = o }
                                side_array.push(side)
                            })
                            let pick = undefined
                            if(picks && picks.length > 0){
                                pick = picks.find(p => p.market_id == m.market_id)
                            }
                            return (
                                <View style={{flex:1}}>
                                    <MarketCard 
                                        align='horizontal' 
                                        market={m} 
                                        pick={pick}
                                        source={source}
                                        side_array={side_array} 
                                        trades_override={trades_override}
                                        event_id={event_id} 
                                        event_type={event_type} 
                                        onPress={(trade) => handleSelectTrade(trade)}
                                        />
                                </View>
                            )
                        })}
                    </View>
                    :
                    <View style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
                        <Icon name='lock' type='feather' color={Colors.brand.midnight} size={28}/>
                    </View>
                    }
                </View>
            </View>
            <View nativeID='footer' style={{ backgroundColor:Colors.shades.shade100, borderBottomRightRadius:12, borderBottomLeftRadius:12 }}>
                {!hide_market_footers && !close_markets ?
                <View style={{ flexDirection:'row'}}>
                    <TouchableOpacity style={{ flex:1, padding:3, paddingLeft:10, flexDirection:'row', alignItems:'center' }} onPress={() => navigation.push('Market', { event_type, event_id, market_id: market_override.market_id, participant_id:athlete_id })}>
                        <View style={{ padding:7, borderRadius:100, backgroundColor:Colors.shades.shade600 }}>
                            <Icon name='bar-chart' type='feather' color={Colors.brand.electric} size={12} />
                        </View>
                        <View style={{ flex:1, padding:7 }}>
                            <Text size={12} color={Colors.brand.midnight}>Liquidity</Text>
                            <Text size={12} color={Colors.brand.electric} weight='bold'>${open_order_amount.toFixed()} • {open_order_count} Open Orders</Text>
                        </View> 
                    </TouchableOpacity>             
                </View>
                :<></>}
            </View>
        </View>
    ) 
}

const styles = {
    cardStyle: { borderRadius: 12, borderWidth: 1, borderColor: Colors.shades.shade400 }
}

export default AthleteEventCard

/*
                <MarketCardFooter 
                    open_order_count={open_order_count}
                    onStatPress={() => navigation.push('Market', { event_type, event_id, market_id: market_override.market_id, participant_id:athlete_id })}
                    onMarketPress={() => navigation.push('Market', { event_type, event_id, market_id: market_override.market_id, participant_id:athlete_id })}
                    />
*/